import { Pipe, PipeTransform } from '@angular/core';

import { DropdownInterface } from '../../../core/models';

@Pipe({
  name: 'searchCompanySource',
  standalone: false
})
export class SearchCompanySourcePipe implements PipeTransform {

  transform(companies: DropdownInterface.ICompaniesDataGeneralSource[], searchValue: string): DropdownInterface.ICompaniesDataGeneralSource[] {
    if (!searchValue.trim()) {
      return companies;
    }
    return companies.filter(company => {
      return (company.name?.toLowerCase().includes(searchValue.toLowerCase())
        || company.id.toString().toLowerCase().includes(searchValue.toLowerCase()));
    });
  }

}
